import React from "react";
import translations from "./newsletter.translations";
import { getLanguageField } from "src/utils/language";

export default class NewsletterCommon extends React.Component<NewsletterComponentCommonProps> {

  /** store form reference for validation */
  public formRef = React.createRef<HTMLFormElement>();

  get email_focus_color_classname(){
    if (this.props.email_focus_color) return "focus:ring-[color:var(--email-focus-color)]"
    return "focus:ring-indigo-600"
  }

  /** on form submit: browser validation passed ok */
  formSubmit: React.FormEventHandler<HTMLFormElement> = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    this.props.onSubmit();
  }

  /** onClick: request form submit and validation */
  onCTAclick = (ev: any) => {
    ev.preventDefault();
    this.formRef.current?.requestSubmit();
  }

  /** render email feedback */
  renderFeedback() {
    if (this.props.feedback === "none") return null;
    const color = this.props.feedback === "subscribed" ? "text-[color:var(--success-feedback-color)]" : "text-[color:var(--error-feedback-color)]";
    const text = getLanguageField(translations, this.props.language, this.props.feedback) as string;
    return <div className={`mt-1 ${color} generalText`}>{text}</div>
  }

  /** render disclaimer block */
  renderDisclaimer() {
    if (!this.props.disclaimer) return null;
    return <div className="mt-4 text-left generalText leading-6 text-[color:var(--disclaimer-color)]">{this.props.disclaimer}</div>
  }

  /** common style props */
  public get style(): React.CSSProperties {
    const { disclaimer_text_color, error_feedback_color, success_feedback_color, email_focus_color } = this.props;
    return {
      "--disclaimer-color": disclaimer_text_color,
      "--success-feedback-color": success_feedback_color || "#65A30D",
      "--error-feedback-color": error_feedback_color || "#DC2626",
      "--email-focus-color": email_focus_color
    } as React.CSSProperties;
  }

}
